// extracted by mini-css-extract-plugin
export default {"tabs-container":"NotesTabs_tabs-container__IN351","tab":"NotesTabs_tab__dKBbz","active":"NotesTabs_active__qLczN","index-line":"NotesTabs_index-line__kJwC1"};